import * as React from 'react';
import { useMachine } from '@xstate/react/lib';
import { Events, Send } from '../../../../../../../Machines/organisations/update';
import machine, { Events as LookSearchEvents, Send as LookSearchSend } from '../../../../../../../Machines/looks/search';
import Filtered from './Filtered';
import All from './All';
import { BranchRecord } from '../../../../../../../Data/organisations/@records/Branch';

const EnterData = (send: LookSearchSend) => (e: React.ChangeEvent<HTMLInputElement>) =>
  send({
    type: LookSearchEvents.ENTER_DATA,
    term: e.target.value,
  });

const SubmitData = (send: LookSearchSend) => (e: React.MouseEvent<HTMLButtonElement>) => send(LookSearchEvents.DATA_SUBMITTED);

const CloseModal = (send: Send) => (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => send(Events.CLOSE_MODAL);

type Props = {
  branch: BranchRecord;
  toggleModal: (v: boolean) => void;
  reloadDetails: () => void;
};

export default ({ branch, toggleModal, reloadDetails }: Props) => {
  const [looksCurrent, looksSend] = useMachine(machine, { devTools: true });

  const toggleModalAndReload = (e: React.MouseEvent) => {
    toggleModal(false);
    reloadDetails();
  };

  return (
    <div id="modal" className="w-screen h-screen absolute top-0 left-0 z-10">
      <div onClick={toggleModalAndReload} className="w-screen h-screen fixed pin bg-black opacity-75" />
      <div className="pin flex items-center left-0 top-0">
        <div className="relative mx-6 md:mx-auto w-full md:w-1/2 lg:w-3/5 xl:w-2/5 z-20 m-8">
          <div className="shadow-lg bg-white rounded-lg p-8">
            <div className="flex justify-end mb-6">
              <button onClick={toggleModalAndReload}>
                <span className="mr-2">Close</span>
                <span>
                  <i className="fa fa-times" />
                </span>
              </button>
            </div>

            <h1 className="text-center text-2xl text-green-dark">Add Look</h1>

            <div className="mb-4">
              <label className="block text-sm font-bold mb-2" htmlFor="email">
                Search
              </label>
              <input
                className="text-input"
                autoFocus={true}
                type="text"
                value={looksCurrent.context.term}
                onChange={EnterData(looksSend)}
                placeholder="Search UserDetailResponse"
              />
            </div>

            <div className="block md:flex items-center justify-center">
              <button
                type="button"
                onClick={SubmitData(looksSend)}
                className="text-grey-lighter font-bold py-1 px-3 rounded text-xs bg-green-200 hover:bg-green-500 transition-250 hover:text-white"
              >
                Search
              </button>
            </div>

            <div className="mt-4">
              {looksCurrent.context.term === '' && <All branch={branch} />}
              {looksCurrent.context.term !== '' && <Filtered current={looksCurrent} branch={branch} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
